import React, { ComponentType } from "react";
import { GeneralButton as GeneralButtonComponent } from "@/app/components/storybook/Button/GeneralButton";
import { GeneralButtonProps } from "@/app/interfaces/props/GeneralButtonProps";
import { ButtonTypeTokensEnum } from "@/enums/tokens/buttonTypeTokensEnum";
import { ControlSizeTokensEnum } from "@/enums/tokens/controlSizeTokenEnum";
import { StateTokensEnum } from "@/enums/tokens/stateTokensEnum";
import { CommonHelper } from "../../../../stories/helpers/CommonHelper";

const iconMap: Record<string, ComponentType<any>> = CommonHelper.getFlattenedIcons(false);
const iconNames = CommonHelper.getSortedIconNames();

const GeneralButton: React.FC<GeneralButtonProps> = ({
  label = "Button",
  size = ControlSizeTokensEnum.DEFAULT,
  buttonType = ButtonTypeTokensEnum.PRIMARY,
  state = StateTokensEnum.DEFAULT,
  iconSize,
  leftIcon,
  rightIcon,
}) => {
  const ResolvedLeftIcon = leftIcon ? iconMap[leftIcon as string] : undefined;
  const ResolvedRightIcon = rightIcon ? iconMap[rightIcon as string] : undefined;

  return (
    <GeneralButtonComponent
      label={label}
      size={size}
      buttonType={buttonType}
      state={state}
      iconSize={iconSize}
      leftIcon={ResolvedLeftIcon}
      rightIcon={ResolvedRightIcon}
    />
  );
};

export default GeneralButton;

export const generalButtonRegistration = {
  name: "General Button",
  inputs: [
    {
      name: "label",
      type: "string",
      defaultValue: "Button",
    },
    {
      name: "buttonType",
      type: "string",
      enum: Object.values(ButtonTypeTokensEnum),
      defaultValue: ButtonTypeTokensEnum.PRIMARY,
    },
    {
      name: "size",
      type: "string",
      enum: Object.values(ControlSizeTokensEnum),
      defaultValue: ControlSizeTokensEnum.DEFAULT,
    },
    {
      name: "state",
      type: "string",
      enum: Object.values(StateTokensEnum),
      defaultValue: StateTokensEnum.DEFAULT,
    },
    {
      name: "iconSize",
      type: "number",
      defaultValue: 20,
    },
    {
      name: "leftIcon",
      type: "string",
      enum: iconNames,
    },
    {
      name: "rightIcon",
      type: "string",
      enum: iconNames,
    },
  ],
  image: "https://unpkg.com/css.gg@2.0.0/icons/svg/shape-square.svg",
  description: "Add a general button component to the page",
};
